import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-16-info.tsx
/**
* icon.16.info
*
* Attention, warning, exclamation mark
*
* Keywords: information, lowercase-i, circle, help, alert, notification, support, rounded-square
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTggMmE2IDYgMCAxIDEgMCAxMkE2IDYgMCAwIDEgOCAybTAgMWE1IDUgMCAxIDAgMCAxMEE1IDUgMCAwIDAgOCAzbTAgNGEuNS41IDAgMCAxIC41LjV2M2EuNS41IDAgMCAxLTEgMHYtM0EuNS41IDAgMCAxIDggN20wLTIuMjVhLjc1Ljc1IDAgMSAxIDAgMS41Ljc1Ljc1IDAgMCAxIDAtMS41Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-11993
*/
const Icon16Info = memo(function Icon16Info(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2m0 1a5 5 0 1 0 0 10A5 5 0 0 0 8 3m0 4a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 8 7m0-2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
		})
	});
});
//#endregion
export { Icon16Info };

//# sourceMappingURL=icon-16-info.js.map